function setToken(token) {
    if (!token) {
        localStorage.removeItem('token');
        setUser()
        return
    }

    localStorage.setItem('token', token)
}

function getToken() {
    return localStorage.getItem('token')
}

function setUser(user) {
    localStorage.setItem('user', JSON.stringify(user))
}

function getUser(defaultValue) {
    const val = localStorage.getItem('user');
    if (val === 'undefined')
        return {}

    return JSON.parse(localStorage.getItem('user')) || defaultValue || {}
}

function setFirmSettings(settings) {
    localStorage.setItem('firm-settings', JSON.stringify(settings))
}

function getFirmSettings(defaultValue) {
    return JSON.parse(localStorage.getItem('firm-settings')) || defaultValue || {}
}

function setLanguage(lang) {
    localStorage.setItem('language', lang)
}

function getLanguage(defaultValue) {
    return localStorage.getItem('language') || defaultValue || 'en'
}

export const LocalStorageService = {
    setUser,
    getUser,
    setToken,
    getToken,
    setLanguage,
    getLanguage,
    setFirmSettings,
    getFirmSettings
}
